module.exports = new __parcel__URL__("metronome1.1c10e9b3.mp3").toString();